export function Brand({ testId = "nav-brand", className = "" }) {
  return (
    <a className={`brand ${className}`} href="#top" aria-label="Affinity Group home" data-testid={testId}>
      <img className="brand-logo" src="/affinity-logo.png" alt="Affinity, A Group Representing Infinity FA" decoding="async" />
    </a>
  );
}
